export default __webpack_public_path__ + "static/media/12.6923a92d.svg";